import React from "react";
import { makeStyles } from "tss-react/mui";
import { Icon, IconColor } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const useStyles = makeStyles()((theme) => ({
  snackbarIconList: {
    background: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
    width: "2em",
    height: "2em",
    fontSize: "0.75em",
    lineHeight: "2em !important",
    textAlign: "center",
    borderRadius: theme.custom.defaultBorderRadius * 1.5
  }
}));
function SnackbarIconUpdate() {
  return /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.Union, color: IconColor.Primary, fontSize: "large" });
}
function SnackbarIconWarning() {
  return /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.WarningOutline, color: IconColor.Primary, fontSize: "large" });
}
function SnackbarIconList() {
  const { classes } = useStyles();
  return /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.CheckList, color: IconColor.PrimaryContrastText, fontSize: "large", className: classes.snackbarIconList });
}
function SnackbarIconSuccess() {
  return /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.CheckDouble, color: IconColor.Primary, fontSize: "large" });
}
export {
  SnackbarIconList,
  SnackbarIconSuccess,
  SnackbarIconUpdate,
  SnackbarIconWarning
};
//# sourceMappingURL=SnackbarIcon.js.map
